import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { School } from './school.model';
import { SchoolService } from './school.service';
import { Principal } from '../../shared/index';
@Injectable()
export class SchoolPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private schoolService: SchoolService,
        private principal: Principal

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        this.principal.hasAnyAuthority(['ROLE_ADMIN']).then(isPlatformAdmin => {
            if (isPlatformAdmin) {
                if (id) {
                    this.schoolService.find(id).subscribe(school => {
                        this.schoolModalRef(component, school);
                    });
                } else {
                    let school: School = new School();
                    school.acceptOnlinePayments = false;
                    school.onlinePaymentsModuleEnabled = false;
                    school.recurrentReservationsModuleEnabled = false;
                    school.invoiceGenerationByStudentEnabled = false;
                    school.onlineTransactionFee = 99;
                    school.onlineTransactionPercentageFee = 1 ;
                    school.subscriptionEndDate = new Date();
                    setTimeout(() => {
                        // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                        return this.schoolModalRef(component, school);
                    });
                }
            } else {
                this.schoolService.findCurrent().subscribe(school => {
                    this.schoolModalRef(component, school);
                });
            }
        });
    }

    schoolModalRef(component: Component, school: School): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.school = school;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school/school-popup.service.ts